import { Box, Divider } from '@mui/material'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { styled } from '@mui/material/styles'
import { useState } from 'react'
import { COLORS } from 'styles/colors'

type TabsFilterType = {
	onClick: (id) => void
	availableTabs: AvailableArrayType[]
	isAllFilter?: boolean
	selectedTab?: number
	selectedKey?: string
	showDivider?: boolean
}
type AvailableArrayType = {
	id?: number
	title: string
	description?: string | number
	key?: string
	badge?: string | number
	badgeColor?: string
}

interface StyledTabsProps {
	children?: React.ReactNode
	value: number
	onChange: (event: React.SyntheticEvent, newValue: number) => void
}

const StyledTabs = styled((props: StyledTabsProps) => (
	<Tabs
		{...props}
		TabIndicatorProps={{ children: <span className='MuiTabs-indicatorSpan' /> }}
	/>
))({
	'& .MuiTabs-indicator': {
		windth: '100%',
		height: '2px',
		borderRadius: '4px',
		display: 'flex',
		justifyContent: 'center',
		backgroundColor: 'transparent',
	},
	'& .MuiTabs-indicatorSpan': {
		borderRadius: '4px',
		width: '100%',
		backgroundColor: COLORS.main,
	},
})

interface StyledTabProps {
	label: React.ReactNode
}

const StyledTab = styled((props: StyledTabProps) => (
	<Tab disableRipple {...props} />
))(() => ({
	textTransform: 'none',
	padding: 0,
	margin: 0,
	marginRight: '16px',
	fontWeight: 600,
	fontSize: 14,
	color: COLORS.secondaryFont,
	'&.MuiTab-root': {
		minWidth: 0,
		'&.Mui-selected': {
			color: COLORS.main,
		},
		'&.Mui-focusVisible': {
			backgroundColor: 'transparent',
		},
	},
}))
const TabsFilter = (props: TabsFilterType) => {
	const {
		availableTabs,
		onClick,
		selectedTab,
		selectedKey,
		showDivider = true,
	} = props
	const [internalValue, setInternalValue] = useState(0)

	// Если передан selectedKey, ищем индекс по ключу
	const selectedIndexFromKey =
		selectedKey !== undefined
			? availableTabs.findIndex(tab => tab.key === selectedKey)
			: undefined

	// Используем selectedTab или selectedKey или внутреннее состояние
	const value =
		selectedIndexFromKey !== undefined && selectedIndexFromKey !== -1
			? selectedIndexFromKey
			: selectedTab !== undefined
				? selectedTab
				: internalValue

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		// Обновляем внутреннее состояние только если компонент неконтролируемый
		if (selectedTab === undefined && selectedKey === undefined) {
			setInternalValue(newValue)
		}

		const selectedId =
			availableTabs[newValue]?.id && availableTabs[newValue]?.id
		const selectedKeyValue =
			availableTabs[newValue]?.key && availableTabs[newValue]?.key
		onClick(
			selectedId ? selectedId : selectedKeyValue ? selectedKeyValue : null,
		)
	}

	return (
		<Box sx={{ width: '100%', position: 'relative' }}>
			<StyledTabs value={value} onChange={handleChange}>
				{/* {isAllFilter && <StyledTab label={'Все'} />} */}
				{availableTabs.map((el, index) => (
					<StyledTab
						key={index}
						label={
							el.badge !== undefined ? (
								<span>
									{el.title}{' '}
									<span style={{ color: el.badgeColor }}>{el.badge}</span>
								</span>
							) : (
								`${el.title}${el.description ? ' ' + el.description : ''}`
							)
						}
					/>
				))}
			</StyledTabs>

			{showDivider && (
				<Divider
					sx={{
						position: 'absolute',
						top: '46px',
						width: '100%',
						borderWidth: '1px',
						borderRadius: '4px',
					}}
				/>
			)}
		</Box>
	)
}

export default TabsFilter
